import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tag, Copy, Check } from "lucide-react";
import { api } from "@/lib/auth";

export const PromoBanner = () => {
  const [b, setB] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.get("/promo/banner").then(r => setB(r.data?.code ? r.data : null)).catch(err => console.warn("Promo banner unavailable:", err?.message)); }, []);
  if (!b) return null;
  const copy = async () => { try { await navigator.clipboard.writeText(b.code); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch (err) { console.warn("Clipboard unavailable:", err?.message); } };
  const ends = b.ends_at ? new Date(b.ends_at + "T23:59:59").toLocaleDateString("en-AU", { day: "numeric", month: "short" }) : null;
  return (
    <div className="bg-emerald-500 text-black text-sm py-2 px-4 flex flex-wrap items-center justify-center gap-3" data-testid="promo-banner">
      <Tag size={14}/>
      <span>{b.text}</span>
      {b.spots_left != null && <span className="font-bold uppercase tracking-widest text-[10px] bg-black/15 px-2 py-0.5">Only {b.spots_left} left</span>}
      {ends && <span className="font-bold uppercase tracking-widest text-[10px] bg-black/15 px-2 py-0.5">Ends {ends}</span>}
      <button type="button" onClick={copy} className="inline-flex items-center gap-1 font-mono font-bold border border-black/30 px-2 py-0.5 hover:bg-black/10" data-testid="promo-banner-copy">
        {copied ? <Check size={12}/> : <Copy size={12}/>}{b.code}
      </button>
      <Link to={b.link || "/timetable"} className="underline font-bold uppercase tracking-widest text-xs" data-testid="promo-banner-link">Book now</Link>
    </div>
  );
};
